import {
  Box,
  Button,
  styled,
  Grid,
  Typography,
  Switch,
  TextField,
  InputAdornment,
  Divider,
} from "@mui/material";
import { IconAction, IconApp, Modal } from "../../";
import SaveIcon from "@mui/icons-material/Save";
import { convertTimeToClient } from "../../../utils/convertTime";
import { useEffect, useState } from "react";
import { useUpdateEvse } from "../../../services/evse";
import { HeaderInfoChargepoint } from "./Header";
import { EAction, IdlingFeeType } from "../../../types/enum";
import { usePermission } from "../../../hooks/CommonContext";
import { ACTION_AUDIT_LOG } from "../../../const/ActionAuditLog";

export const ModalIdlingPenalty = (props: {
  open: boolean;
  onClose: () => void;
  init?: IEvse;
  success: () => void;
  selectTypeAuditLog: (arg: { type: string; action: string }) => void;
}) => {
  const [evse, setEvse] = useState<Partial<IEvse>>({});
  const [valueInput, setValueInput] = useState(0);
  const [feeMaximumInput, setFeeMaximumInput] = useState(0);
  const [fixedInput, setFixedInput] = useState(0);

  const { idlingSetting } = usePermission();
  useEffect(() => {
    setEvse({
      idle_timing_enabled: props.init?.idle_timing_enabled,
      idle_grace_period: props.init?.idle_grace_period,
      idle_timing_0: props.init?.idle_timing_0,
      idle_timing_1: props.init?.idle_timing_1,
      idle_timing_2: props.init?.idle_timing_2,
      idle_timing_3: props.init?.idle_timing_3,
      idle_timing_4: props.init?.idle_timing_4,
      idle_timing_5: props.init?.idle_timing_5,
      idle_timing_6: props.init?.idle_timing_6,
      idling_fee_type: props.init?.idling_fee_type || IdlingFeeType.PER_MINUTE,
      idle_grace_fee: props.init?.idle_grace_fee || 0,
      idling_fee_maximum: props.init?.idling_fee_maximum || 0,
    });
    setFeeMaximumInput(props.init?.idling_fee_maximum || 0);
    setValueInput(
      props.init?.idling_fee_type === IdlingFeeType.PER_MINUTE || !props.init?.idling_fee_type
        ? props.init?.idle_grace_fee || 0
        : 0
    );
    setFixedInput(
      props.init?.idling_fee_type === IdlingFeeType.FIXED
        ? props.init?.idle_grace_fee || 0
        : 0
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.init?._id]);

  const { mutateAsync } = useUpdateEvse();

  const handleUpdate = async () => {
    try {
      const idle_grace_fee =
        evse.idling_fee_type === IdlingFeeType.PER_MINUTE ? valueInput : fixedInput;

      const result = await mutateAsync({
        id: props.init?._id!,
        dto: {
          ...evse,
          idle_grace_fee,
          action_type: ACTION_AUDIT_LOG.EDIT_IDLING_PENALTY,
        },
      });
      if (result) {
        props.success();
        props.onClose();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Modal
      {...props}
      name="Idling penalty"
      description="View & edit your charge point’s pricing"
      icon={<IconApp width={"27px"} name={"IdLingPenalty"} />}
    >
      <Box display={"flex"} flexDirection="column" gap={"30px"}>
        <HeaderInfoChargepoint
          model={props.init?.model}
          current_type={props.init?.current_type}
          max_p={props.init?.max_p}
          locationName={props.init?.Location?.name}
          ampeco_evse_id={props.init?.ampeco_evse_id}
        />
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            justifyContent={"space-between"}
            alignItems="center"
          >
            <Box>
              <Typography fontSize={"14px"}>Idling penalty function</Typography>
              <Typography fontSize={"10px"} color="#9B9B9B">
                (Toggle to activate or deactivate function)
              </Typography>
            </Box>
            <Switch
              checked={evse?.idle_timing_enabled}
              onChange={(e) =>
                setEvse({ ...evse, idle_timing_enabled: e.target.checked })
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box>
              <Typography fontSize={"14px"}>Grace Period</Typography>
              <Typography fontSize={"10px"} color="#9B9B9B">
                (Time allowance for late-comers)
              </Typography>
            </Box>
            <Box display={"flex"} gap={1} mt={1}>
              {[15, 30, 60].map((_, _index: number) => {
                return (
                  <BoxValue
                    active={evse?.idle_grace_period === `${_}`}
                    onClick={() =>
                      setEvse({ ...evse, idle_grace_period: `${_}` })
                    }
                  >
                    <Typography fontSize={"20px"} fontWeight="bold">
                      {_} <span style={{ fontWeight: "normal" }}>mins</span>
                    </Typography>
                  </BoxValue>
                );
              })}
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <Typography fontSize={"14px"}> Idling Fee Rules</Typography>
              <Typography fontSize={"10px"} color="#9B9B9B">
                (Time allowance for late-comers)
              </Typography>
            </Box>
            <Box display={"flex"} gap={1} mt={1}>
              <Box
                flex={1}
                onClick={() =>
                  setEvse((prev) => ({ ...prev, idling_fee_type: IdlingFeeType.PER_MINUTE }))
                }
                border={"1px solid #C7C7C7"}
                bgcolor={evse.idling_fee_type === IdlingFeeType.PER_MINUTE ? "#FFFF00" : ""}
                borderRadius={"8px"}
                sx={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                }}
              >
                <Typography
                  fontSize={"20px"}
                  fontWeight={"700"}
                  color={evse.idling_fee_type === IdlingFeeType.PER_MINUTE ? "black" : "#9B9B9B"}
                >
                  Base on duration
                </Typography>
                <Typography
                  fontSize={"13px"}
                  fontWeight={"500"}
                  color={evse.idling_fee_type === IdlingFeeType.PER_MINUTE ? "black" : "#9B9B9B"}
                >
                  (Charging incurs a per-minute fee)
                </Typography>
              </Box>
              <Box
              flex={1}
                display="flex"
                flexDirection={"column"}
                justifyContent="space-between"
              >
                <Box display={"flex"} justifyContent="space-between" alignItems={"start"} mb={"5px"}>
                  <Box sx={{display:"flex", alignItems:"start", justifyContent:"flex-start", flexDirection:"column"}}>
                    <Typography fontSize={"14px"}>
                      Idling Penalty Fee (/min)
                    </Typography>
                    <Typography fontSize={"12px"}>
                      New
                    </Typography>
                  </Box>
                  <Typography
                    fontSize={"14px"}
                    display="flex"
                    alignItems={"center"}
                    gap="3px"
                  >
                    S${" "}
                    <span style={{ fontSize: "18px", color: "#565656" }}>
                        {
                        evse.idling_fee_type === IdlingFeeType.PER_MINUTE
                          ? valueInput !== undefined && !isNaN(valueInput) ? valueInput.toFixed(2) : "0.00"
                          : fixedInput !== undefined && !isNaN(fixedInput) ? fixedInput.toFixed(2) : "0.00"
                        }
                    </span>
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  type="number"
                  autoComplete="off"
                  value={valueInput}
                  disabled={evse.idling_fee_type !== IdlingFeeType.PER_MINUTE}
                  onChange={(e) => {
                    const val = parseFloat(e.target.value);
                    setValueInput(val);
                  }}
                  inputProps={{ step: "0.01", min: "0" }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">S$</InputAdornment>,
                  }}
                />
              </Box>
            </Box>
            </Grid>
            <Grid item xs={12}>
            <Box
              flex={1}
                display="flex"
                flexDirection={"column"}
                justifyContent="space-between"
              >
                <Box display={"flex"} justifyContent="space-between" alignItems={"start"} mb={"5px"}>
                  <Box sx={{display:"flex", alignItems:"start", justifyContent:"flex-start", flexDirection:"column"}}>
                  <Typography fontSize={"14px"}>
                    Maximum penalty fee($)
                  </Typography>
                  <Typography fontSize={"12px"}>
                    New
                    <Typography display={"inline"} fontSize={"10px"} fontStyle={"italic"}>
                      (set 0 as unlimited)
                    </Typography>
                  </Typography>
                  </Box>
                  <Typography
                    fontSize={"14px"}
                    display="flex"
                    alignItems={"center"}
                    gap="3px"
                  >
                    S${" "}
                    <span style={{ fontSize: "18px", color: "#565656" }}>
                      {props.init?.idling_fee_maximum}
                    </span>
                  </Typography>
                </Box>
                <TextField
                  // size="small"
                  fullWidth
                  autoComplete="off"
                  value={feeMaximumInput}
                  onChange={(e) =>{
                    setFeeMaximumInput(+e.target.value)
                    setEvse((prev) => ({
                      ...prev,
                      idling_fee_maximum: +e.target.value,
                    }))
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">S$</InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Grid>
            <Divider sx={{mt:"30px", bgcolor:"#C7C7C7", width:"100%"}}/>
            <Grid item xs={12} md={12}>
            <Box display={"flex"} gap={1} mt={1}>
              <Box
                flex={1}
                onClick={() =>
                  setEvse((prev) => ({ ...prev, idling_fee_type: IdlingFeeType.FIXED }))
                }
                border={"1px solid #C7C7C7"}
                bgcolor={evse.idling_fee_type === IdlingFeeType.FIXED ? "#FFFF00" : ""}
                borderRadius={"8px"}
                sx={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                }}
              >
                <Typography
                  fontSize={"20px"}
                  fontWeight={"700"}
                  color={evse.idling_fee_type === IdlingFeeType.FIXED ? "black" : "#9B9B9B"}
                >
                  1 time charger
                </Typography>
                <Typography
                  fontSize={"13px"}
                  fontWeight={"500"}
                  color={evse.idling_fee_type === IdlingFeeType.FIXED ? "black" : "#9B9B9B"}
                >
                  (Fixed penalty varies depending on charging location.)
                </Typography>
              </Box>

              <Box
              flex={1}
                display="flex"
                flexDirection={"column"}
                justifyContent="space-between"
              >
                <Box display={"flex"} justifyContent="space-between" alignItems={"start"} mb={"5px"}>
                  <Box sx={{display:"flex", alignItems:"start", justifyContent:"flex-start", flexDirection:"column"}}>
                  <Typography fontSize={"14px"}>
                    Fixed idling penalty fee
                  </Typography>
                  <Typography fontSize={"12px"}>
                    New
                  </Typography>
                  </Box>

                  <Typography
                    fontSize={"14px"}
                    display="flex"
                    alignItems={"center"}
                    gap="3px"
                  >
                    S${" "}
                    <span style={{ fontSize: "18px", color: "#565656" }}>
                      {fixedInput !== undefined && !isNaN(fixedInput)
                        ? fixedInput.toFixed(2)
                        : "0.00"
                      }
                    </span>
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  type="number"
                  autoComplete="off"
                  value={fixedInput}
                  disabled={evse.idling_fee_type !== IdlingFeeType.FIXED}
                  onChange={(e) => {
                    const val = parseFloat(e.target.value);
                      setFixedInput(val);
                  }}
                  inputProps={{ step: "0.01", min: "0" }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">S$</InputAdornment>,
                  }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <Typography fontSize={"14px"}>Customise your idling penalty schedule</Typography>
              <Typography fontSize={"10px"} color="#9B9B9B">
                (Set the timing you wish to impose idling penalty)
              </Typography>
            </Box>
            </Grid>
            <Grid item xs={12} md={12} sx={{display:"none", justifyContent:"space-between", alignItems:"center"}}>
              <Box>
                <Typography fontSize={"14px"}>Full automation</Typography>
                <Typography fontSize={"10px"} color="#9B9B9B">
                  (Set up the others base on 1 day only)
                </Typography>
              </Box>
              <Switch
                checked={evse?.idle_timing_enabled}
                onChange={(e) =>
                  setEvse({ ...evse, idle_timing_enabled: e.target.checked })
                }
              />
            </Grid>
          </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <DayField
              day="Sunday"
              value={evse?.idle_timing_0 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_0: e })}
            />
          </Grid>
          <Grid item xs={4}>
            <DayField
              day="Monday"
              value={evse?.idle_timing_1 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_1: e })}
            />
          </Grid>
          <Grid item xs={4}>
            <DayField
              day="Tuesday"
              value={evse?.idle_timing_2 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_2: e })}
            />
          </Grid>
          <Grid item xs={4}>
            <DayField
              day="Wednesday"
              value={evse?.idle_timing_3 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_3: e })}
            />
          </Grid>
          <Grid item xs={4}>
            <DayField
              day="Thursday"
              value={evse?.idle_timing_4 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_4: e })}
            />
          </Grid>
          <Grid item xs={4}>
            <DayField
              day="Friday"
              value={evse?.idle_timing_5 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_5: e })}
            />
          </Grid>
          <Grid item xs={4}>
            <DayField
              day="Saturday"
              value={evse?.idle_timing_6 || ""}
              onChange={(e) => setEvse({ ...evse, idle_timing_6: e })}
            />
          </Grid>
        </Grid>

        <Box display={"flex"} justifyContent="end">
          <IconAction
            title="Audit Log"
            onClick={() => {
              props.selectTypeAuditLog({
                type: "evse",
                action: "edit_idling_penalty",
              });
            }}
            icon={<IconApp name="History" width={20} height={20} />}
          />
        </Box>

        <Grid container spacing={2}>
          {idlingSetting?.includes(EAction.UPDATE) && (
            <Grid item xs={8}>
              <Button
                variant="contained"
                fullWidth
                size="large"
                startIcon={<SaveIcon fontSize="large" />}
                onClick={handleUpdate}
              >
                Save change
              </Button>
            </Grid>
          )}
          <Grid item xs={4}>
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="inherit"
              onClick={props.onClose}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

const _Text = styled(Typography)({ color: "#9B9B9B" });

const DayField = ({
  day,
  value,
  onChange,
}: {
  day: string;
  value: string;
  onChange?: (e: string) => void;
}) => {
  const { from, to } = convertTimeToClient(value);
  const enabled = from && to;

  const handleChangeTime = (type: "from" | "to", value: string) => {
    if (!value || !enabled) return;

    if (type === "from") {
      onChange?.(`${value}-${to}`);
    } else {
      onChange?.(`${from}-${value}`);
    }
  };

  return (
    <Box>
      <Box
        display={"flex"}
        alignItems="center"
        gap={"15px"}
        // justifyContent={"space-between"}
      >
        <Typography fontSize={"13px"}>{day}</Typography>
        <Switch checked={!!enabled} onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              onChange?.("00:00-23:59");
            } else {
              onChange?.("-");
            }
          }}
        />
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextField
            onChange={(e) => handleChangeTime("from", e.target.value)}
            value={from}
            autoComplete="off"
            size="small"
            fullWidth
            type={"time"}
            disabled={!enabled}
          />
          {/* <TimePicker */}
          {/*   value={moment()} */}
          {/*   slots={{ */}
          {/*     textField: (params) => ( */}
          {/*       <TextField */}
          {/*         autoComplete="off" */}
          {/*         size="small" */}
          {/*         {...params} */}
          {/*         fullWidth */}
          {/*       /> */}
          {/*     ), */}
          {/*   }} */}
          {/* /> */}
        </Grid>
        <Grid item xs={6}>
          <TextField
            onChange={(e) => handleChangeTime("to", e.target.value)}
            value={to}
            autoComplete="off"
            size="small"
            fullWidth
            type={"time"}
            disabled={!enabled}
          />
          {/* <TimePicker */}
          {/*   value={moment(to)} */}
          {/*   slots={{ */}
          {/*     textField: (params) => ( */}
          {/*       <TextField */}
          {/*         autoComplete="off" */}
          {/*         size="small" */}
          {/*         {...params} */}
          {/*         fullWidth */}
          {/*       /> */}
          {/*     ), */}
          {/*   }} */}
          {/* /> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export const BoxValue = styled(Box)<{ active: boolean }>(({ active }) => ({
  width: "100%",
  border: `0.5px solid ${active ? "#FFFF00" : "#C7C7C7"}`,
  color: active ? "black" : "unset",
  background: active ? "#FFFF00" : "unset",
  borderRadius: "4px",
  padding: "12px 20px",
  textAlign: "center",
  cursor: "pointer",
  span: {
    fontSize: "13px",
    color: active ? "black" : "#9B9B9B",
  },
}));

const _TextName = styled(Typography)({
  fontSize: "17px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});
